import React from 'react'
import { useHistory } from 'react-router-dom'

import style from './MyhouseNoticeListCategory.module.scss'

import { MY_HOUSE_NOTICE_CATEGORY, MY_HOUSE_NOTICE_CATEGORY_LIST } from '@Root/contants/myhouse'
import useNotice from '@Hooks/myhouse/notice/useNotice'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const MyhouseNoticeListCategory: React.FC = () => {
  const { notice } = useNotice()
  const history = useHistory()
  const { currentCategory } = notice

  const onClick = (category: MY_HOUSE_NOTICE_CATEGORY) => (event: React.SyntheticEvent) => {
    handleNclick(NCLICK.MY_HOUSE.NOTICE_LIST.TAB[category], event)

    history.replace({
      pathname: window.location.pathname,
      search: `?category=${category}`,
    })
  }

  const categoryList = MY_HOUSE_NOTICE_CATEGORY_LIST.map((category) => {
    return {
      text: category.SUMMARY_LABEL,
      category: category.CODE,
      pressed: currentCategory === category.CODE,
    }
  })

  return (
    <div className={style.myhouse_category} role="tablist">
      <div className={style.myhouse_category_inner} id="tabCategory">
        {categoryList &&
          categoryList.map((item: any, i: any) => (
            <button
              key={style.myhouse_category_item + i}
              className={style.myhouse_category_item}
              type="button"
              role="tab"
              aria-selected={item.pressed} // tab 기능이라면 aria-pressed 아닌 aria-selected 로 적용 필요.
              onClick={onClick(item.category)}
            >
              {item.text}
            </button>
          ))}
      </div>
    </div>
  )
}

export default MyhouseNoticeListCategory
